//@flow
import React, { useState } from 'react';
import { Formik, FormikValues } from 'formik';
import { RouteComponentProps } from 'react-router-dom';
import { Button, FormGroup, Label } from 'reactstrap';
import isBefore from 'date-fns/is_before';
import { stringify } from 'query-string';
import { decamelizeKeys } from 'humps';
import { getCustomToast } from '../../../components/ErrorMessage';

import { 
  createInitialValues,
  TransportationDateRangePicker,
  injectTransportationSearchParams,
  createDataForInvoice,
  useTransportationJson,
} from '../Common';
import { createInvoice } from '../../../services/cart';
import { CustomCounter, WhitePanel, CustomRadioGroup } from '../../../components';
import { TRIP_TYPE_OPTIONS } from '../Common/constants';

type Props = RouteComponentProps & {
  onSuccess: () => void,
};

const TransportDateAndPaxForm = (props: Props) => {
  const { queryParams } = props;
  const [isLoading, setIsLoading] = useState(false);
  const transportaionData = useTransportationJson();
  return (
    <Formik
      validate={validateForm}
      initialValues={createInitialValues(queryParams)}
      onSubmit={async (values: FormikValues) => {
        const { history } = props;
        const formData = { ...values };
        const isOneWay = formData.tripType === 'O';
        if (isOneWay) delete formData.arrivalDate;
        formData.tripType = formData.tripType2;
        setIsLoading(true);
        const data = transportaionData ? transportaionData.filter(t => t.id === queryParams.id) : null;
        try {
          history.push({
            pathname: '/transportation/details',
            search: `?${stringify(decamelizeKeys({
              ...queryParams,
              ...formData,
            }))}`,
          });
          const invoiceId = await createInvoice(createDataForInvoice(data[0], formData));
          history.push(`payment/${invoiceId}`);
        } catch(e) {
          getCustomToast('Some problem occured. Please try again', 'error');
          setIsLoading(false);
        }
      }}
    >
      {({ handleSubmit }) => {
        return (
          <WhitePanel>
            <h2 id="transport-booking-form-2">Booking Details</h2>
            <div className="radio-wrap">
              <Label className="sr-only">Trip</Label>
              <FormGroup>
                <CustomRadioGroup name="tripType2" options={TRIP_TYPE_OPTIONS} />
              </FormGroup>
            </div>
            <section className="select__date">
            <div className="select__date_checkin_checkout">
              <FormGroup>
                <TransportationDateRangePicker name="checkinDate" />
              </FormGroup>
            </div>
            <div className="select__date_guest">
              <CustomCounter title="Passengers" />
            </div>
            <div className="select__date_action">
              <Label className="title" style={{ visibility: 'hidden' }}>Submit button</Label>
              <Button
                color="yellow"
                disabled={isLoading}
                onClick={handleSubmit}
              >
                Book
              </Button>
            </div>
          </section>
          </WhitePanel>
        );
      }}
    </Formik>
  );
};

function validateForm(values) {
  const { arrivalDate, departureDate, tripType } = values;
  const isRoundTrip = tripType === 'R';

  let errors = {};

  if (isRoundTrip) {
    if (!arrivalDate) errors.arrivalDate = 'Please enter your arrival date';
    if (isBefore(arrivalDate, departureDate)) errors.arrivalDate = 'Arrival date cannot be before than departure date';
  }
  
  if (!departureDate) errors.departureDate = 'Please enter your departure date';

  return errors;
}


TransportDateAndPaxForm.defaultProps = {
  onSuccess: () => { },
};

export default injectTransportationSearchParams(TransportDateAndPaxForm);



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationDetails/TransportDateAndPaxForm.jsx